import React, { useEffect, useState } from "react";
import StlMultiplePreview from "./components/StlMultiplePreview";
import { API_URL } from "../../config";
import { OrderContainer } from "../../common/components/Container";
import { useLocation, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Backdrop } from "@mui/material";
import Spinner from "../../common/components/Spinner";
import { useNavigate } from "react-router-dom";
import {
  faPlay,
  faAngleLeft,
  faAngleRight,
  faUndoAlt,
} from "@fortawesome/free-solid-svg-icons";
import { Button } from "@mui/material";
import { GlobalContainer } from "../../common/components/Container";
import { StyledLink } from "../../common/components/Title/styles";
const StlSlideShow = () => {
  const { state } = useLocation();
  const [blobLinks, setBlobLinks] = useState([]);
  const [fileNames, setFileNames] = useState([]);

  const [loading, setLoading] = useState(false);
  const [offSetXForNextStl, setOffSetXForNextStl] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(1);
  const [currentFileName, setCurrentFilename] = useState("");

  const navigate = useNavigate();

  function isStlExtension(filename) {
    let filename_lower = filename.toLowerCase();
    var parts = filename_lower.split(".");
    if (parts[parts.length - 1] === "stl") {
      return "stl";
    } else if (parts[parts.length - 1] === "ply") {
      return "ply";
    } else {
      return "others";
    }
  }

  const getFile = async () => {
    try {
      setBlobLinks([]);
      setLoading(true);
      let count = 0;
      for (const file of state) {
        console.log(file);
        if (isStlExtension(file.fileName) !== "others") {
          // if (count === 0) {
          //   setCurrentFilename(file.fileName);
          // }
          console.log(API_URL + `file/${file.id}/download`);
          await fetch(API_URL + `file/${file.id}/download`).then((response) => {
            response.blob().then((blob) => {
              let url = window.URL.createObjectURL(blob);
              console.log(url);
              setFileNames((prev) => [...prev, file.fileName]);
              setBlobLinks((prev) => [
                ...prev,
                { fileType: isStlExtension(file.fileName), url: url },
              ]);
            });
          });
          count++;
        }
      }

      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getFile();
  }, [state]);

  useEffect(() => {
    setCurrentFilename(fileNames[currentSlide - 1]);
  }, [fileNames, currentSlide]);

  useEffect(() => {
    let i = 1;
    let intervalId;
    if (isPlaying && blobLinks.length !== 1) {
      intervalId = setInterval(() => {
        setOffSetXForNextStl((prev) => (prev += 200));
        setCurrentSlide((prev) => (prev += 1));

        i++;
        if (i >= blobLinks.length) {
          setIsPlaying(false);
        }
      }, 1000);
      return () => clearInterval(intervalId);
    } else {
      clearInterval(intervalId);
    }
  }, [isPlaying, blobLinks.length]);

  const playSlideShow = () => {
    setCurrentSlide(1);
    setOffSetXForNextStl(0);
    setIsPlaying(true);
  };

  const resetSlideShow = () => {
    setCurrentSlide(1);
    setOffSetXForNextStl(0);
    setIsPlaying(false);
  };

  const nextSlide = () => {
    if (currentSlide !== blobLinks.length) {
      setCurrentSlide((prev) => (prev += 1));
      setOffSetXForNextStl((prev) => (prev += 200));
    }
  };

  const previousSlide = () => {
    if (currentSlide !== 1) {
      setCurrentSlide((prev) => (prev -= 1));
      setOffSetXForNextStl((prev) => (prev -= 200));
    }
  };

  return (
    <GlobalContainer theme="purple" bgColor={"#fff"}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div style={{ display: "block" }}>
            <Spinner />
          </div>
          <div style={{ display: "block", marginTop: "30px" }}>
            Loading STLs
          </div>
        </div>
      </Backdrop>
      {!loading && (
        <div>
          <StyledLink
            style={{
              paddingTop: "20px",
              cursor: "pointer",
              fontSize: "13px",
            }}
            theme="green"
            onClick={() => navigate(-1)}
          >
            <FontAwesomeIcon
              style={{ fontSize: "19px", paddingRight: "12px" }}
              icon={faAngleLeft}
              FontAwesomeIcon
            />
            Back to Case
          </StyledLink>
          <StlMultiplePreview
            links={blobLinks}
            offSetXForNextStl={offSetXForNextStl}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                fontFamily: "Inter",
                fontWeight: 700,
                marginBottom: "10px",
              }}
            >
              {currentFileName}
            </div>
            <div
              style={{
                fontFamily: "Inter",
                fontWeight: 700,
                marginBottom: "10px",
              }}
            >
              {currentSlide}/{blobLinks.length}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              style={{
                minWidth: "40px",
                height: "40px",
                borderRadius: "50%",
                backgroundColor: "#161616",
                color: "white",
                fontSize: "20px",
                padding: 0,
                margin: "5px",
              }}
              onClick={previousSlide}
            >
              <FontAwesomeIcon icon={faAngleLeft} />
            </Button>

            <Button
              style={{
                minWidth: "50px",
                height: "50px",
                borderRadius: "50%",
                backgroundColor: "#161616",
                color: "white",
                fontSize: "20px",
                padding: 0,
                margin: "5px",
              }}
              onClick={() => (!isPlaying ? playSlideShow() : resetSlideShow())}
            >
              {!isPlaying ? (
                <FontAwesomeIcon icon={faPlay} />
              ) : (
                <FontAwesomeIcon icon={faUndoAlt} />
              )}
            </Button>

            <Button
              style={{
                minWidth: "40px",
                height: "40px",
                borderRadius: "50%",
                backgroundColor: "#161616",
                color: "white",
                fontSize: "20px",
                padding: 0,
                margin: "5px",
              }}
              onClick={nextSlide}
            >
              <FontAwesomeIcon icon={faAngleRight} />
            </Button>
          </div>
        </div>
      )}
    </GlobalContainer>
  );
};

export default StlSlideShow;
